import { useEffect, useState } from "react"
import type { SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useQuotation({ page, keyword, limit, sort }: PaginationType) {
  const api = useApi()
  const [data, setData] = useState<DataList>(defaultValue)
  const [isLoading, setLoading] = useState(false)

  const params: { [key: string]: number | string | undefined } = {};
  if (page) params.page = page;
  if (keyword) params.keyword = keyword;
  if (limit) params.limit = limit;
  if (sort) params.sort = sort;

  const getQuotationData = () => api.get("/religion/", { params })

  const fetchingQuotation = () => {
    setLoading(true)
  
    getQuotationData()
    .then((res: SuccessFetch<{ payload: DataList }>) => setData(res.data.payload))
    .catch(() => setData(defaultValue))
    .finally(() => setLoading(false))
  }

  const refetch = () => fetchingQuotation()

  useEffect(() => {
    refetch()

    return () => {
      setData(defaultValue)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])
  useEffect(() => {
    fetchingQuotation()

    return () => {
      setData(defaultValue)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [page, keyword, limit, sort])

  return { data, isLoading, refetch }
}

type PaginationType = {
  page?: number
  keyword?: string
  limit?: number,
  sort?: string
}
type DataList = {
  items: any[]
  pagination_data: {
    total: number
    page: number
    size: number
    pages: number
  }
}
const defaultValue = {
  items: [],
  pagination_data: {
    page: 0,
    pages: 0,
    size: 0,
    total: 0
  }
}